import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router";

const SESSION_KEY = "portalSession";

export interface PortalSession {
  token: string;
  firstName: string;
  lastName: string;
  email: string;
  expiresAt: string;
}

export function setPortalSession(data: PortalSession): void {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
}

export function getPortalSession(): PortalSession | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as PortalSession) : null;
  } catch {
    return null;
  }
}

export function updatePortalExpiry(expiresAt: string): void {
  const session = getPortalSession();
  if (session) setPortalSession({ ...session, expiresAt });
}

export function clearPortalSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
}

export function PortalGuard() {
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const session = getPortalSession();
    if (!session) {
      navigate("/", { replace: true });
      return;
    }
    if (new Date(session.expiresAt) <= new Date()) {
      clearPortalSession();
      navigate("/", { replace: true });
      return;
    }
    setAllowed(true);
  }, [navigate]);

  if (!allowed) return null;
  return <Outlet />;
}
